import { downgradeComponent } from '@angular/upgrade/static';
import { module } from 'angular';

import { State } from './';
import { default as mailInProcessWorkspaceName, MailInProcessWorkspace } from './in-process/mail-in-process-workspace.component';
import { default as mailAcceptingActionsName, MailAcceptingActions } from './mail-accepting-actions.component';
import { default as mailAllocatedName, MailAllocated } from './mail-allocated.component';
import { default as mailAskForHelpActionsName, MailAskForHelpActions } from './mail-askForHelp-actions.component';
import { default as mailAskForHelpWorkspaceName, MailAskForHelpWorkspace } from './mail-askForHelp-workspace.component';
import { default as mailAttachmentName, MailAttachment } from './mail-attachment.component';
import { default as mailCloseWorkspaceName, MailCloseWorkspace } from './mail-close-workspace.component';
import {
  default as mailCommentAskForHelpReviewViewName,
  MailCommentAskForHelpReviewView,
} from './mail-comment-askForHelp-review-view.component';
import { default as mailDisplayActionsName, MailDisplayActions } from './mail-display-actions.component';
import { default as mailHeaderAnswerActionsName, MailHeaderAnswerActions } from './mail-header-answer-actions.component';
import { default as mailInProcessActionsName, MailInProcessActions } from './mail-in-process-actions.component';
import { default as mailInfoName, MailInfo } from './mail-info.component';
import { default as mailOutgoingSelectionActionsName, MailOutgoingSelectionActions } from './mail-outgoing-selection-actions.component';
import { default as mailOutgoingSelectionInfoName, MailOutgoingSelectionInfo } from './mail-outgoing-selection-info.component';
import {
  default as mailOutgoingSelectionWorkspaceName,
  MailOutgoingSelectionWorkspace,
} from './mail-outgoing-selection-workspace.component';
import { default as mailPostTreatmentActionsName, MailPostTreatmentActions } from './mail-post-treatment-actions.component';
import { default as mailQualificationWorkspaceName, MailQualificationWorkspace } from './mail-qualification-workspace.component';
import { default as mailTransferActionsName, MailTransferActions } from './mail-transfer-actions.component';
import { default as mailTransferWorkspaceName, MailTransferWorkspace } from './mail-transfer-workspace.component';
import { default as mailWorkspaceConfigurationService, MailWorkspaceConfigurationService } from './mail-workspace-configuration.service';
import { MailTransferCompositeFormComponent } from './transfer-composite-form/mail-transfer-composite-form.component';

export default module('contact.agent.contact-view.mail', [State])
  .component(mailAcceptingActionsName, new MailAcceptingActions())
  .component(mailAllocatedName, new MailAllocated())
  .component(mailAskForHelpActionsName, new MailAskForHelpActions())
  .component(mailAskForHelpWorkspaceName, new MailAskForHelpWorkspace())
  .component(mailCommentAskForHelpReviewViewName, new MailCommentAskForHelpReviewView())
  .component(mailDisplayActionsName, new MailDisplayActions())
  .component(mailInProcessActionsName, new MailInProcessActions())
  .component(mailInProcessWorkspaceName, new MailInProcessWorkspace())
  .component(mailInfoName, new MailInfo())
  .component(mailOutgoingSelectionActionsName, new MailOutgoingSelectionActions())
  .component(mailOutgoingSelectionInfoName, new MailOutgoingSelectionInfo())
  .component(mailOutgoingSelectionWorkspaceName, new MailOutgoingSelectionWorkspace())
  .component(mailPostTreatmentActionsName, new MailPostTreatmentActions())
  .component(mailQualificationWorkspaceName, new MailQualificationWorkspace())
  .component(mailTransferActionsName, new MailTransferActions())
  .component(mailTransferWorkspaceName, new MailTransferWorkspace())
  .component(mailHeaderAnswerActionsName, new MailHeaderAnswerActions())
  .component(mailCloseWorkspaceName, new MailCloseWorkspace())
  .component(mailAttachmentName, new MailAttachment())
  .directive(
    'mailTransferCompositeForm',
    downgradeComponent({ component: MailTransferCompositeFormComponent }) as angular.IDirectiveFactory
  )
  .service(mailWorkspaceConfigurationService, MailWorkspaceConfigurationService).name;
